import moment from "moment";
import SubCommentBox from "./SubCommentBox";
import { SUBDOMAIN } from "../../../assets/meta/meta";
import { useAuthContext } from "../../../Components/AuthContext";
import { Button } from "../../../Components/Common/Tailwind";
import { sanitizeRichHtml } from "../../../utils/sanitizeRichHtml";

function CommentBox({ id, user_id, username, content, profile_img, images, written_date, onReply, subComments, onDelete }) {
  const { userInfo } = useAuthContext();
  const self_user_id = userInfo.id;
  const profileImageUrl = profile_img || `https://${SUBDOMAIN}.${window.AMZ_ENV?.VITE_DOMAIN || "amazingticket.site"}/amazingpark-logo.png`;

  function hyperlinkUrls(text = "") {
    const urlRegex = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|]|www\.[-A-Z0-9+&@#\/%?=~_|!:,.;]*\.[a-z]{2,})/gi;

    // Replace URLs with hyperlinks
    let updatedText = text.replace(urlRegex, function (url) {
      let prefixedUrl = url.startsWith("www.") ? `http://${url}` : url;
      return `<a href="${prefixedUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    return updatedText;
  }

  const safeContent = sanitizeRichHtml(hyperlinkUrls(content || ""));

  return (
    <div key={id}>
      <div className="flex flex-row justify-content-start align-content-start gap-3 m-2 mb-4">
        {/* <a href="#" className="pull-left"> */}
        <div>
          <img src={profileImageUrl} alt="" className="rounded-circle" style={{ width: "35px", height: "35px" }} />
        </div>
        <div className="media-body" style={{ width: "100%" }}>
          <span className="">
            <strong className="text-primary">{username}</strong>
          </span>
          <span className="text-muted mx-2">
            <small className="text-muted" style={{ fontSize: "11px" }}>
              {moment(written_date).format("YYYY-MM-DD HH:mm")}
            </small>
          </span>
          <Button
            type="button"
            variant="link"
            size="sm"
            className="p-0 h-auto align-baseline"
            style={{ boxShadow: "none" }}
            onClick={() =>
              onReply({
                id,
                username,
                content,
              })
            }
          >
            댓글
          </Button>
          {String(self_user_id) === String(user_id) ? (
            <Button
              type="button"
              variant="link"
              size="sm"
              className="p-0 h-auto align-baseline"
              style={{ boxShadow: "none" }}
              onClick={() => {
                if (window.confirm("정말로 댓글을 삭제하시겠습니까?")) onDelete(id);
              }}
            >
              삭제
            </Button>
          ) : null}

          <div dangerouslySetInnerHTML={{ __html: safeContent }} style={{ maxWidth: "600px", marginTop: "5px", lineHeight: "24px", marginBottom: "10px", width: "90%" }} />

          {images
            ? images.map((image) => (
              <div key={image.id}>
                <img src={`${image.image}`} style={{ maxWidth: "200px", width: "100%", cursor: "pointer" }} alt="commentimg" onClick={() => window.open(image.image, "_blank")} />
              </div>
            ))
            : null}
        </div>
      </div>
      <div>{subComments ? subComments.map((item) => <SubCommentBox key={item.id} {...item} onDelete={(_id) => onDelete(_id)} />) : null}</div>
    </div>
  );
}

export default CommentBox;
